import React, { Component } from 'react';
import FormCreate from './FormCreate'
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2/dist/sweetalert2.js";

class Index extends Component {
    constructor(props){
        super(props)
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            modal: false,
            modeEdit: false,
            showTable: false,
            format_pdf_id: "",

            form: {
                format_id: this.props.format.id,
                name: "", 
                content: "",
            },

        }
    }

    HandleChange = (e) => {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value,
            }
        });
    }

    toogle = (from) => {
        if (from == "new") {
            this.setState({ modal: true })
            this.clearValues();
        } else {
            this.setState({ modal: false })
        }
    }

    //add items
    updateData = (data) => {
        this.setState({
            data: [...this.state.data, data],
        })
    }

    //add update
    updateItem = format => {
        this.setState({
            data: this.state.data.map(item => {
                if (format.id === item.id) {
                    return {
                        ...item,
                        name: format.name,
                        content: format.content
                    }
                }
                return item;
            })
        });
    }

    clearValues = () => {
        this.setState({
            modeEdit: false,

            form: {
                ...this.state.form,
                name: "", 
                content: "",
            },
        })
    }

    delete = id => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¡El registro será eliminado para siempre!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si"
        }).then(result => {
            if (result.value) {
                fetch(`/formatos/format_pdfs/${id}`, {
                    method: "delete",
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                .then(response => response.json())
                .then(response => {
                    this.loadData()
                    this.messageSuccess(response)
                });
            }
        });
    };

    componentDidMount = () => {
        this.loadData();
    }

    loadData = () => {
        fetch(`/formatos/get_format_pdfs/${this.props.format.id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
          this.setState({
            data: data.data,
            isLoaded: false
          });
        });
    }

    HandleClick = () => {
        if (this.state.modeEdit) {
            fetch(`/formatos/format_pdfs/${this.state.format_pdf_id}`, {
                method: 'PATCH', // or 'PUT'
                body: JSON.stringify(this.state.form), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": this.token,
                    "Content-Type": "application/json"
                }
            })

                .then(res => res.json())
                .catch(error => console.error("Error:", error))
                .then(data => {
                    this.updateItem(data.register)
                    this.clearValues();
                    this.setState({ modal: false })
                });
        } else {
            fetch(`/formatos/format_pdfs`, {
                method: 'POST', // or 'PUT'
                body: JSON.stringify(this.state.form), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": this.token,
                    "Content-Type": "application/json"
                }
            })
                .then(res => res.json())
                .catch(error => console.error("Error:", error))
                .then(data => {
                    this.updateData(data.register)
                    this.clearValues();
                    this.setState({ modal: false, showTable: true })
                });
        }
    }


    edit = (format_pdf) => {
        this.setState({
            modal: true,
            modeEdit: true,
            format_pdf_id: format_pdf.id,
            form: {
                ...this.state.form,
                name: format_pdf.name, 
                content: format_pdf.content,
            }
        })
    }

    HandleChangeCkaditor = (e) => {
        this.setState({
            form:{
                ...this.state.form,
                content: e
            }
        })
    }

    render() {
        return (
            <React.Fragment>
                {this.state.modal && (
                    <FormCreate
                        backdrop={"static"}
                        modal={this.state.modal}
                        toggle={this.toogle}
                        title={this.state.modeEdit ? "Actualizar PDF" : "Crear PDF"}
                        nameBnt={this.state.modeEdit ? "Actualizar" : "Crear"}

                        //form props
                        formValues={this.state.form}
                        onChangeForm={this.HandleChange}
                        submitForm={this.HandleClick}
                        HandleChangeCkaditor={this.HandleChangeCkaditor}
                    />
                )}

                <div className="card mb-3">
                    <div className="card-header" style={{ display: "flow-root", paddingTop: 12 }}>
                        Pdf de formato

                        <a
                            className="btn-shadow btn btn-info float-right"
                            href={`/formatos/format_categories/${this.props.format_category.id}/formats/${this.props.format.id}/format_pdfs`}
                            data-turbolinks="false"
                        >
                            Crear
                        </a>

                        <a className="float-right mr-3" data-toggle="collapse" href="#collapseExampleFormatPdf" role="button" aria-expanded="false" aria-controls="collapseExampleFormatPdf">
                            <i className="fas fa-angle-down"></i>
                        </a>
                    </div>

                    <div className="card-body p-3">
                        <div className="row">

                            <div className={`collapse ${this.state.showTable ? "show" : ""} w-100`} id="collapseExampleFormatPdf">
                                <div className="col-md-12">
                                    <table className="table table-hover table-striped table-bordered" id="sampleTable">
                                        <thead>
                                            <tr>
                                                <th>Nombre</th>
                                                <th></th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {this.state.data.length >= 1 ? (
                                                this.state.data.map(format_pdf => (
                                                    <tr key={format_pdf.id}>
                                                        <td>{format_pdf.name}</td>
                                                        {true && (
                                                            <td className="text-right" style={{ width: "10px" }}>
                                                                    <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                                                                        <div className="btn-group" role="group">
                                                                            <button
                                                                                className="btn-shadow btn btn-info"
                                                                                id="btnGroupDrop1"
                                                                                type="button"
                                                                                data-toggle="dropdown"
                                                                                aria-haspopup="true"
                                                                                aria-expanded="false"
                                                                            >
                                                                                <i className="fas fa-bars"></i>
                                                                            </button>
                                            
                                                                            <div className="dropdown-menu dropdown-menu-right">

                                                                                {true && (
                                                                                    <a
                                                                                        className="dropdown-item"
                                                                                        href={`/formatos/format_categories/${this.props.format_category.id}/formats/${this.props.format.id}/format_pdfs/${format_pdf.id}`}
                                                                                        data-turbolinks="false"
                                                                                        target="_blank"
                                                                                        
                                                                                    >
                                                                                        Editar
                                                                                    </a>
                                                                                )}

                                                                                {true && (  
                                                                                    <button
                                                                                        onClick={() => this.delete(format_pdf.id)}
                                                                                        className="dropdown-item"
                                                                                    >
                                                                                        Eliminar
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                            </td>
                                                        )}
                                                    </tr>
                                                ))
                                            ) : (
                                                    <tr>
                                                        <td colSpan="8" className="text-center">
                                                            <div className="text-center mt-4 mb-4">
                                                                <h4>No hay registros</h4>
                                                            </div>
                                                        </td>
                                                    </tr>
                                            )}
                                        </tbody>
                                    </table>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Index;
